import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  AfterViewInit,
  OnDestroy
} from "@angular/core";
import { IMostAffectedSate } from "./models/most-affected-warehouses";
import { MostAffectedWarehousesService } from "./services/widget-most-affected-warehouses.service";
import { TranslateService } from "@ngx-translate/core";
import * as HSET from "./settings";
import { GenericUtils } from "./../../../utilities/generic-utils";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: "widget-warehouse-most-affected-warehouse",
  templateUrl: "./widget-warehouse-most-affected-warehouses.component.html",
  styleUrls: ["./widget-warehouse-most-affected-warehouses.scss"],
  providers: [MostAffectedWarehousesService]
})
export class WidgetWarehouseMostAffectedWarehousesComponent
  implements OnInit, OnChanges, AfterViewInit, OnDestroy {
    private unsubscribe: Subject<void> = new Subject();
  @Input() TITLE: string;
  @Input() HEADINGS: string[] = [];
  @Input() FILTERS: object = {};
  @Input() OPTIONS;
  loaderValue = true;

  tableData = null;
  errorMessage = "";
  mockData = null;

  constructor(
    private dataService: MostAffectedWarehousesService,
    private translateService: TranslateService,
    private utils: GenericUtils
  ) { }

  ngAfterViewInit() {
    this.getMostAffectedWarehouses();
  }

  ngOnInit() {
    this.translateService
      .get("WAREHOUSE.MOST_AFFECTED_WAREHOUSES")
      .pipe(takeUntil(this.unsubscribe)).subscribe(text => {
        this.OPTIONS.title = this.OPTIONS.title || text;
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      this.getMostAffectedWarehouses();
    }
  }

  getMostAffectedWarehouses() {
    this.tableData = null;
    this.mockData = null;
    this.errorMessage = "";
    const query = JSON.parse(JSON.stringify(this.FILTERS));
    query.page_offset = "6";
    this.dataService.getMostAffectedWarehouses(this.OPTIONS, query)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        response => {
          if (response.data[0] && Object.keys(response.data[0]).length && response.data[0].WarehouseMostAffected.length) {
            this.loaderValue = false;
            this.tableData = response.data[0].WarehouseMostAffected;
            this.tableData.map(data => {
              data.total_value = this.utils.amountIndianUnit(data.total_value);
              return data;
            });
          } else {
            this.errorMessage = "ERROR_MSG.NO_DATA";
            this.mockData = HSET.data;
            this.HEADINGS = HSET.mostAffectedWarehousesColumns;
          }
        },
        error => {
          this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
          this.mockData = HSET.data;
          this.HEADINGS = HSET.mostAffectedWarehousesColumns;
        }
      );
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
